import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "CCE About Management (Web)")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "card-body p-lg-17" }
const _hoisted_8 = { class: "mb-18" }
const _hoisted_9 = { class: "mb-10" }
const _hoisted_10 = { class: "text-center mb-15" }
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_ctx.can('read', 'cce'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.can('update', 'cce'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary justify-content-end",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('cce-about-editing-web')))
                  }, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('updateAbout')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "fs-5 fw-semibold mt-15",
                  innerHTML: _ctx.about.data.data.htmlEn
                }, null, 8, _hoisted_11)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}